// extracted by mini-css-extract-plugin
module.exports = {"modal":"MyDialog_modal_qeIhX","darkSide":"MyDialog_darkSide_1g1TA"};